"use client";

import { useUser } from "@/context/user-context";
import classNames from "classnames";
import Icon from "./icon";

type TagProps = {
  label: string;
  className?: string;
  showFollowToggle?: boolean;
};

const Tag = ({ label, className, showFollowToggle }: TagProps) => {
  const { user, toggleTopic } = useUser();

  const isSubscribed = user
    ? user?.topics?.find((item) => item.id === label && item.type === "tag")
    : false;

  return (
    <span
      className={classNames(
        `px-3 py-2 mb-2 mr-2 btn font-bold flex items-center ${className}`,
        {
          "pl-1.5 bg-sand-700": isSubscribed,
          "cursor-pointer": user,
        }
      )}
      onClick={() => (user ? toggleTopic({ type: "tag", id: label }) : null)}
    >
      {user && showFollowToggle && isSubscribed && (
        <Icon.Check className="h-4 mr-1" aria-label="följer" />
      )}
      <span className="leading-tight">{label}</span>
    </span>
  );
};

export default Tag;
